import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import TextInput from "@/components/inputs/TextInput.vue";
import LoaderIcon from "@/components/icons/LoaderIcon.vue";
import ConfirmButton from "@/views/Auth/components/ConfirmButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SignupModalContent',
  props: {
    waitApiCall: { type: Boolean }
  },
  emits: ["signup"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;

const { t } = useI18n();

const email = ref<string>("");
const password = ref<string>("");
const passwordConfirm = ref<string>("");

const isCredentialsValid = computed(() => {
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return (
    emailRe.test(email.value) &&
    password.value &&
    password.value.length > 0 &&
    password.value === passwordConfirm.value
  );
});

function handleSignUp() {
  if (!isCredentialsValid.value) {
    return;
  }
  emits("signup", email.value, password.value, passwordConfirm.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TextInput, {
      label: _unref(t)('auth.email'),
      modelValue: email.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
      type: "email",
      class: "mb-4"
    }, null, 8, ["label", "modelValue"]),
    _createVNode(TextInput, {
      label: _unref(t)('auth.password'),
      modelValue: password.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
      type: "password",
      class: "mb-4"
    }, null, 8, ["label", "modelValue"]),
    _createVNode(TextInput, {
      label: _unref(t)('auth.confirm-password'),
      modelValue: passwordConfirm.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordConfirm).value = $event)),
      type: "password",
      class: "mb-10"
    }, null, 8, ["label", "modelValue"]),
    _createVNode(ConfirmButton, {
      disabled: !isCredentialsValid.value || __props.waitApiCall,
      loading: __props.waitApiCall,
      "button-text": _unref(t)('auth.sign-up'),
      onClick: handleSignUp
    }, null, 8, ["disabled", "loading", "button-text"])
  ], 64))
}
}

})